import { useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1180px] items-center gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <span className="font-heading text-lg font-bold leading-none">91</span>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              91下载
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.22em] text-foreground-500">
              RESOURCE INDEX
            </span>
          </span>
        </a>

        <nav className="ml-2 hidden items-center gap-1 lg:flex">
          {navItems.slice(1).map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="cursor-pointer rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2 md:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索软件 / 影视 / 游戏 / 视频"
              className="w-40 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none xl:w-52"
            />
          </div>
          <button
            type="button"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-700 md:inline-flex"
          >
            登录 / 注册
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((value) => !value)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2 md:hidden">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索资源"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            {navItems.slice(1).map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            className="mt-3 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            登录 / 注册
          </button>
        </div>
      )}
    </header>
  );
}